import VuexPersistence from 'vuex-persist'
import { debounce } from '~/lib/helpers/debounce'
import { useSessionStorage } from '~/lib/helpers/storage'

const storage = useSessionStorage()

const saveStateToStorage = (_key, state) => {
  const filteredState = {
    editor: {
      current_logo: state.editor.current_logo,
      logo_preset: state.editor.logo_preset,
      logo: state.editor.logo,
      custom_keywords: state.editor.custom_keywords,
    },
    billing: state.billing,
    session: state.session,
    cart: {
      ...state.cart,
      client_logos: undefined,
    },
  }

  storage.setItem('state', JSON.stringify(filteredState))
}

const saveState = debounce(saveStateToStorage, 100)

const restoreState = () => JSON.parse(sessionStorage.getItem('state'))

export default ({ store }) =>
  new VuexPersistence({
    key: 'state',
    saveState,
    restoreState,
    storage,
  }).plugin(store)
